import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import Avatar from '@atlaskit/avatar';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';

import type { PersonProfileData } from '../../types';

const messages = defineMessages({
	managerHeading: {
		id: 'user-profile-card.manager.heading',
		defaultMessage: 'Manager',
		description: 'Section title for the manager row on the user profile card',
	},
});

interface ManagerSectionProps {
	manager: NonNullable<PersonProfileData['manager']>;
}

export function ManagerSection({ manager }: ManagerSectionProps): React.JSX.Element | null {
	const intl = useIntl();
	const { name, avatarUrl, jobTitle } = manager;
	if (!name) {
		return null;
	}

	return (
		<Stack space="space.100">
			<Text as="p" weight="medium" color="color.text">
				{intl.formatMessage(messages.managerHeading)}
			</Text>
			<Inline space="space.150" alignBlock="center">
				<Avatar src={avatarUrl ?? undefined} name={name} size="medium" />
				<Stack>
					<Text maxLines={1}>{name}</Text>
					{jobTitle && (
						<Text size="small" color="color.text.subtlest" maxLines={1}>
							{jobTitle}
						</Text>
					)}
				</Stack>
			</Inline>
		</Stack>
	);
}
